<div class="cloak" *ngIf="!hideCloak"></div>
<div class="wrapper" [ngClass]="{ 'sidebar-closed': !sharedService.sidebarOpen }">
    <app-header></app-header>
    <app-sidebar></app-sidebar>
    <div class="main">
        <router-outlet></router-outlet>
    </div>
</div>

<div class="toast-container">
    <ngb-toast
        [class]="toast.classname"
        [autohide]="false"
        [delay]="toast.delay || 5000"
        (hidden)="toastService.remove(toast)"
        *ngFor="let toast of toastService.toasts"
    >
        <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
            <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
        </ng-template>

        <ng-template #text>{{ toast.textOrTpl }}</ng-template>
    </ngb-toast>
</div>
